import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas"; // Import html2canvas
import "./MaxAllocationCert.scss";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/NewIcons/IconDownload.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/NewIcons/exitIcon.svg";
import certificateImg from "../../../assets/images/Max Allocation Template.jpg"; // Larger certificate image
import ShareCertiWithSocialmedia from "../ShareCertiWithSocialmedia";

const MaxAllocationCert = ({
  data,
  publicShareTrue = false,
  image = false,
}) => {
  const certificate = data;
  const [open, setOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(
    publicShareTrue ? data : null
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = (certificate) => {
    setSelectedCertificate(certificate);
    setOpen(true);
    setImageLoaded(false);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCertificate(null);
  };

  const downloadCertificateWithDetails = () => {
    const certificateElement = document.getElementById("certificateContainer");

    if (certificateElement) {
      html2canvas(certificateElement, {
        scale: 4, // Ensure high resolution
        useCORS: true, // Enable cross-origin images
      }).then((canvas) => {
        // Create a new canvas for fixed dimensions
        const resizedCanvas = document.createElement("canvas");
        resizedCanvas.width = 1968; // Fixed width
        resizedCanvas.height = 1483; // Fixed height

        const context = resizedCanvas.getContext("2d");
        context.drawImage(
          canvas,
          0,
          0,
          canvas.width,
          canvas.height,
          0,
          0,
          resizedCanvas.width,
          resizedCanvas.height
        );

        // Convert resized canvas to image
        const dataUrl = resizedCanvas.toDataURL("image/png");

        // Trigger download
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${selectedCertificate?.name}_certificate.png`;
        link.click();
      });
    } else {
      console.error("Certificate element not found for download.");
    }
  };

  const handleSmallDownload = () => {
    // Open the modal first
    setOpen(true);
    setSelectedCertificate(certificate);

    setTimeout(() => {
      downloadCertificateWithDetails();
    }, 300); // Adding a slight delay to ensure the modal is opened before the download happens
  };
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  return (
    <>
      {!publicShareTrue && (
        <div className="maxAllocationCertSmallerContainer">
          <div className="certificateSmallerWrapper">
            <div key={certificate.id} className="small_certificate_container">
              <div className="topSection">
                <div className="downloadBtn">
                  <DownloadIcon
                    onClick={handleSmallDownload} // Trigger the download and modal open on click
                  />
                </div>
                <div className="certificateTitle">
                  <h3 className="certificate_title">{certificate?.title}</h3>
                </div>
              </div>
              <div
                className={`certificateImgContainer ${image ? "phase1certificateImg" : ""
                  }`}
              >
                <img
                  src={certificateImg} // Display small certificate image
                  alt="Certificate"
                  className="small_certificate_image"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpen(certificate)} // Open the larger certificate on click
                />
                <div className="small_certificate_name">
                  {certificate?.name}
                </div>
                <div className="small_certificate_date">
                  {certificate?.created_at}
                </div>
              </div>
              <div
                className="frame-btn-container"
                style={{ marginTop: "10px", textAlign: "center" }}
              >
                <a
                  href="https://fundedaward.com/products/ac-award?ta_aff=capital"
                  target="_blank"
                  rel="noreferrer"
                  className="frame-certificate-btn"
                >
                  Frame Certificate
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {(open || publicShareTrue) && (
        <div
          className={`${publicShareTrue ? "stage1certificateCardOverlayShare" : ""
            } fundedoverlaymaxAllocationCertContainer`}
          onClick={handleClose}
        >
          <div
            className="mainWrappermaxAllocationCert certificateCardContainer"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="containermaxAllocationCert">
              <div className="maxAllocationCertDetails">
                <div className="leftSectionDetails certificatePopModalHeader">
                  <div className="topSection">
                    <div className="titleSection">
                      <p>{certificate?.title}</p>
                    </div>
                  </div>
                  <div className="bottomSection">
                    {" "}
                    <div className="downloadDiv">
                      <DownloadIcon
                        onClick={downloadCertificateWithDetails} // Download the certificate with image and details
                      />{" "}
                    </div>
                    {!publicShareTrue && (
                      <div className="rightSection">
                        <div style={{ display: "flex", gap: "10px" }}>
                          <ShareCertiWithSocialmedia
                            data={selectedCertificate}
                          />
                          <div className="rightSectionDetails">
                            <div className="crossbtn" onClick={handleClose}>
                              <CrossIcon />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`imgContainerDiv ${image ? "phase1ContainerDiv" : ""
                  }`}
                id="certificateContainer"
              >
                <img
                  src={certificateImg} // Display small certificate image
                  alt="Certificate"
                  className="certificate_image"
                  style={{ cursor: "pointer" }}
                  onLoad={() => setImageLoaded(true)}
                />
                {imageLoaded && (
                  <>
                    <p className="large_certificate_name">
                      {selectedCertificate?.name}
                    </p>
                    <p className="large_certificate_date">
                      {selectedCertificate?.created_at}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MaxAllocationCert;
